import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import { Grid, Label, Segment } from 'semantic-ui-react';
import { Loader } from '../../Elements';
import appStyles from '../../App/App.scss';
import styles from '../Financial.scss';
import currencyFormatter from 'currency-formatter';
import Waypoint from 'react-waypoint';
import moment from 'moment-timezone';
import paymentsHelper from '../../../lib/utils/payments';

class CompletedPayments extends Component {
  static propTypes = {
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      listSize: 20
    };
    this.transition = this.transition.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  loadMore() {
    if (this.props.relay.hasMore() && !this.state.loading) {
      this.props.relay.loadMore(20, () => {
        this.setState({ loading: false, listSize: this.state.listSize + 20 });
      });
      this.setState({ loading: true });
    }
  }

  transition(to) {
    this.props.router.push(to);
  }

  render() {
    const timeZone = this.props.viewer.s_time_zone;
    return (
      <div>
        <Segment className={appStyles.segmentContainer}>
          <Grid>
            <Grid.Row only='computer tablet' className={styles.tableHeader}>
              <Grid.Column width={4}>
                <strong>Invoice</strong>
              </Grid.Column>
              <Grid.Column width={3}>
                <strong>Paid By</strong>
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                <strong>Payment Amount</strong>
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                <strong>Date Paid</strong>
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                <strong>Payment Method</strong>
              </Grid.Column>
            </Grid.Row>
            {this.props.viewer.completed_payments.edges.map(payment => [
              <Grid.Row
                only='mobile'
                onClick={this.transition.bind(
                  null,
                  `/docs/i/${payment.node.invoice.id}`
                )}
                key={`${payment.node.id}_mobile`}
                className={styles.tableRow}
              >
                <Grid.Column width={16}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                      <strong>
                        {payment.node.invoice.title}
                      </strong>
                      <div className={styles.eventTitleMobile}>
                        {
                          payment.node.invoice.workspaces.edges[0].node.event
                            .title
                        }
                      </div>
                      <div className={styles.paymentSummary}>
                        Paid by {payment.node.name} on{' '}
                        <span
                          title={`${moment
                            .tz(payment.node.paid_at, timeZone)
                            .format('MMM D, YYYY [at] LT')} ${moment
                            .tz(timeZone)
                            .format('z')}`}
                        >
                          {moment
                            .tz(payment.node.paid_at, timeZone)
                            .format('L')}
                        </span>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <strong>
                        {currencyFormatter.format(
                          payment.node.amount_cents / 100,
                          { code: payment.node.amount_currency }
                        )}
                      </strong>
                      <br />
                      <Label
                        style={{ marginTop: '0.5em' }}
                        basic
                        size='small'
                        color='black'
                      >
                        {paymentsHelper.payments(payment.node)}
                      </Label>
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>,
              <Grid.Row
                onClick={this.transition.bind(
                  null,
                  `/docs/i/${payment.node.invoice.id}`
                )}
                className={styles.tableRow}
                only='computer tablet'
                key={`${payment.node.id}_computer`}
              >
                <Grid.Column width={4}>
                  <div>
                    <strong>
                      {payment.node.invoice.title}
                    </strong>
                  </div>
                  <div className={styles.mutedText}>
                    {payment.node.invoice.workspaces.edges[0].node.event.title}
                  </div>
                </Grid.Column>
                <Grid.Column width={3}>
                  {payment.node.name}
                </Grid.Column>
                <Grid.Column width={3} textAlign='right'>
                  {currencyFormatter.format(payment.node.amount_cents / 100, {
                    code: payment.node.amount_currency
                  })}
                </Grid.Column>
                <Grid.Column width={3} textAlign='right'>
                  <p
                    title={`${moment
                      .tz(payment.node.paid_at, timeZone)
                      .format('MMM D, YYYY [at] LT')} ${moment
                      .tz(timeZone)
                      .format('z')}`}
                  >
                    {moment.tz(payment.node.paid_at, timeZone).format('L')}
                  </p>
                </Grid.Column>
                <Grid.Column width={3} textAlign='right'>
                  {paymentsHelper.payments(payment.node)}
                </Grid.Column>
              </Grid.Row>
            ])}
            {this.props.viewer.completed_payments.edges.length === 0 &&
              <Grid.Row columns='equal'>
                <Grid.Column>
                  <h4 style={{ textAlign: 'center', margin: '2em' }}>
                    You have no completed payments
                  </h4>
                </Grid.Column>
              </Grid.Row>}
          </Grid>
        </Segment>
        <Waypoint onEnter={this.loadMore} bottomOffset={-200} />
        {this.props.relay.hasMore() &&
          this.state.loading &&
          <div style={{ marginBottom: '2em', textAlign: 'center' }}>
            <Loader
              active
              inline
              size='tiny'
              style={{ marginRight: '1em' }}
            />{' '}
            Loading More...
          </div>}
      </div>
    );
  }
}

export default withRouter(CompletedPayments);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Payments/CompletedPaymentsComponent.js